<template>
  <div class="single-code-analysis-chart-container" :id="chartid"></div>
</template>

<script>
export default {
  name: 'BarChart',
  props: {
    chartid: String,
    charttitle: String,
    chartdata: {
      type: Object
    }
  },
  created() {
    this.$nextTick(() => {
      this.initBarChart(this.chartdata)
    });
  },
  computed: {
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.initBarChart(this.chartdata)
      });
    },
  },
  methods: {
    initBarChart: function(chartdata){
      let myBarChart = this.echarts.init(document.getElementById(this.chartid));
      myBarChart.clear()
      myBarChart.setOption({
        legend: {
          top: 0,
          right: 30,
          bottom: 0,
          icon: 'rect'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: chartdata.tooltipFormatter
        },
        // grid: {
        //   left: 80,
        //   top:50,
        //   bottom:chartdata.gridbottom,
        //   right:80,
        // },
        grid: chartdata.gridbottom,
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#FFF',
            interval: 0,//全部显示
            rotate: chartdata.axisLabelrotate
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#8697ab'
            }
          },
          data: chartdata.xAxis
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            color: '#FFF',
            interval: 'auto',
            formatter: chartdata.yAxisFormatter
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#8697ab',
            }
          }
        },
        series: chartdata.yAxis,
        color: chartdata.color ? chartdata.color : ['#7290F2', '#F47373', '#7290F2', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      }); 
    }
  }
}
</script>
